import React from 'react';
import styles from '../../styles/components/card.module.scss';
import Icons from '../../public/assets/svg';
import Router from "next/router";

export default function index() {

    const createBot = () => {
        Router.push("/botDetailPage");
    }
    return (
        <div className={styles.cardWrapper}>
            <div className={styles.cardHead}>
                <div className={styles.icon}><Icons name="shoppingIcon" className={styles.shoppingIcon} /></div>
                <div className={styles.text}>
                    <p className={styles.code}>5310</p>
                    <p className={styles.label}>Content Marketing</p>
                </div>
            </div>
            <div className={styles.cardBody}>
                <p className={styles.title}>Web Scrapping for E-commerce channels</p>
                <p className={`${styles.label} ${styles.rejectStatus}`}>LIVE</p>
                <p className={styles.content}>
                    <span className={styles.title}>Area</span>
                    <span className={styles.text}>Purchasing Indirect</span>
                </p>
                <p className={styles.content}>
                    <span className={styles.title}>Area</span>
                    <span className={styles.text}>Purchasing Indirect</span>
                </p>
            </div>
            <div className={styles.cardFoot}>
                <span className={styles.actionBtn} onClick={createBot}><Icons name="whitelist" className={styles.listIcon}></Icons>View Details</span>
            </div>
        </div>
    )
}

